module.exports = __webpack_public_path__ + "img/diapositiva-5-3.0be0d1e9.png";